<template>
  <div @click="$emit('select')">
    <label class="radio-btn" :class="{'is-checked': isSelected}">
      <input type="radio" :name="name" :checked="isSelected"/>
      <i></i>
      <!--    <span></span>-->
    </label>
  </div>
</template>

<script>
export default {
  name: 'BaseRadio',
  emits: ['select'],
  components: {},
  props: {
    value: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      default: 'opinion'
    }
  },
  watch: {
    value(newValue) {
      this.isSelected = newValue;
    }
  },
  data() {
    return {
      isSelected: this.value
    };
  },
  mounted() {
    this.isSelected = this.value;
  },
  methods: {},
};
</script>

<style scoped lang="scss">

.radio-btn {
  display: block;

  * {
    pointer-events: none;
  }

  input {
    display: none;
    pointer-events: none;
  }

  i {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    vertical-align: middle;
    border: 1px solid var(--solid-lavender-grey);
    transition: .25s;
    pointer-events: none;
  }

  input:checked + i {
    box-shadow: inset 0 0 0 5px var(--solid-purple);
  }

  &.is-checked {
    i {
      box-shadow: inset 0 0 0 5px var(--solid-purple);
      border-color: var(--solid-purple);
    }
  }

  &:hover {
    cursor: pointer;

    i {
      border: 1px solid var(--solid-purple);
    }
  }
}
</style>
